export default {
  // Profile page sections
  myProfile: "Mi Perfil",
  savedProducts: "Productos Guardados",
  myReviews: "Mis Reseñas",
  settings: "Configuración",
  
  // Profile settings
  profileSettings: "Configuración del Perfil",
  country: "País",
  phoneNumber: "Número de Teléfono",
  socialMedia: "Redes Sociales",
  privacySettings: "Configuración de Privacidad",
  
  // Privacy options
  publicProfile: "Perfil Público",
  privateProfile: "Perfil Privado",
  contactsOnly: "Solo Contactos",
  
  // Profile actions
  uploadPhoto: "Subir Foto",
  removePhoto: "Eliminar Foto",
  uploadSuccess: "Foto subida exitosamente",
  uploadError: "Error al subir la foto",
  photoTooBig: "La foto debe ser menor a 2MB",
  
  // Social links
  instagramLink: "Perfil de Instagram",
  tiktokLink: "Perfil de TikTok",
  addSocialLinks: "Agregar Enlaces de Redes Sociales",
  
  // Reviews section
  userReviews: "Reseñas",
  noReviews: "Aún no hay reseñas",
  loginToSeeReview: "Inicia sesión para ver la reseña completa",
  
  // Follow functionality
  following: "Siguiendo",
  follow: "Seguir",
  followers: "seguidores",
  followSuccess: "Usuario seguido exitosamente",
  unfollowSuccess: "Dejaste de seguir al usuario",
  nowFollowing: "Ahora sigues a {{username}}",
  noLongerFollowing: "Ya no sigues a {{username}}",
  
  // Private profile messages
  followToRequest: "Sigue a este usuario para solicitar acceso a su perfil",
  followToSee: "Sigue a este usuario para ver sus reseñas y marcas favoritas",
  
  // Expertise level
  level: "Nivel",
  expert: "Experto",
  
  // Favorite brands
  favoriteBrands: "Marcas Favoritas",
  addBrand: "Agregar marca",
  brandAdded: "Marca agregada exitosamente",
  brandRemoved: "Marca eliminada exitosamente",
  
  // Tips preferences
  tipsPreferences: "Preferencias de Propinas",
  acceptTips: "Aceptar Propinas",
  tipPreferences: "Preferencias de Propinas",
  
  // Save changes
  saveChanges: "Guardar Cambios",
  changesSaved: "Cambios guardados exitosamente",
  savingChanges: "Guardando cambios...",
  errorSaving: "Error al guardar los cambios"
};